
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ValidationProvider} from 'vee-validate';

@Component({components: {ValidationProvider}})
export default class TextInput extends Vue {
  @Prop({default: 'text'}) type!: string;
  @Prop({required: true}) id!: string;
  @Prop({required: true}) value!: string;
  @Prop() label!: string;
  @Prop() placeholder!: string;
  @Prop() disabled!: boolean;
  @Prop() rules!: [Object, String];

  innerValue: string = '';

  created() {
    this.innerValue = this.value;
  }

  @Watch('innerValue')
  onValueChange(value: string) {
    this.$emit('input', value);
  }

  @Watch('value')
  onOutValueChange(value: any) {
    this.innerValue = value;
  }
}
